import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';
import { useDeps } from '@Contexts/DI';

import type { UseQueryResult } from '@tanstack/react-query';
import type { MenuData } from '@Types/Profile';

export type ViewType = 'short' | 'full';

export function useProfileMenu(view: ViewType): UseQueryResult<MenuData[]> {
  const { cabinetApi } = useDeps();
  const request = useRequest();
  const { country, language } = request;
  const keys = ['cabinet', 'menu', view, country, language];

  const query = useQuery({
    queryKey: keys,
    queryFn: () => cabinetApi.getMenu(view, country),
    enabled: true,
    placeholderData: (previousData) => previousData,
  });
  return query;
}
